import { OptionType } from '@medely/ui-kit';

export const EMPLOYMENT_TYPE_OPTIONS: OptionType[] = [
  { value: 0, label: 'Per diem' },
  { value: 1, label: 'Full Time' },
  { value: 2, label: 'Part Time' },
  { value: 3, label: 'Travel contract' },
  { value: 4, label: 'Internship' },
];

export const NON_CLINICAL_EMPLOYMENT_TYPE_OPTIONS: OptionType[] = [
  { value: 1, label: 'Full Time' },
  { value: 2, label: 'Part Time' },
];

export const YES_NO_OPTIONS: OptionType[] = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export const NON_CLINICAL_FIELDS = [
  'clinical',
  'position_title',
  'currently_work_here',
  'start_date',
  'end_date',
  'employment_type',
  'description',
  'organization_name',
  'location',
  'state_id',
  'id',
];

export const TRAUMA_LEVEL_OPTIONS: OptionType[] = [
  { value: 'level_i', label: 'Level I' },
  { value: 'level_ii', label: 'Level II' },
  { value: 'level_iii', label: 'Level III' },
  { value: 'level_iv', label: 'Level IV' },
  { value: 'level_v', label: 'Level V' },
];

export const LOCATION_IS_TEACHING_HOSPITAL_OPTIONS: OptionType[] = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
